import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.textbook.study');
import { OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-textbook-study',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.textbook.study/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}

.study-wrap {
  min-height: 100%;
  background: #f5f6f8;
}

.blur-box {
  position: absolute;
  background: rgba(59, 130, 246, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1.5px solid rgba(59, 130, 246, 0.3);
  z-index: 10;
}
.blur-box:hover {
  background: rgba(59, 130, 246, 0.25);
  border-color: rgba(59, 130, 246, 0.5);
}
.blur-box.active {
  background: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}
.blur-box.answered {
  background: rgba(168, 85, 247, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-color: rgba(168, 85, 247, 0.4);
}
.blur-box.correct {
  background: rgba(34, 197, 94, 0.15);
  backdrop-filter: none;
  border-color: rgba(34, 197, 94, 0.5);
  border-width: 2px;
}
.blur-box.wrong {
  background: rgba(239, 68, 68, 0.1);
  backdrop-filter: none;
  border-color: rgba(239, 68, 68, 0.5);
  border-width: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.blank-badge {
  position: absolute;
  top: -8px;
  left: -8px;
  width: 16px;
  height: 16px;
  background: #3b82f6;
  color: white;
  font-size: 9px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11;
}

.wrong-answer-label {
  font-size: 10px;
  font-weight: 600;
  color: #dc2626;
  white-space: nowrap;
  text-shadow: 0 0 3px white, 0 0 3px white;
}`],
})
export class PageTextbookStudyComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('imageContainer') imageContainer: ElementRef;

    public loading: boolean = true;
    public textbookId: string = '';
    public pageNum: number = 1;
    public totalPages: number = 0;
    public textbook: any = null;

    // 이미지 기반 데이터
    public imageSrc: string = '';
    public imageWidth: number = 0;
    public imageHeight: number = 0;
    public blanks: any[] = [];
    public totalBlanks: number = 0;

    // 답안 상태
    public answers: any = {};
    public checked: boolean = false;
    public score: number = 0;
    public correctCount: number = 0;

    // 활성 빈칸 (클릭해서 입력 중인)
    public activeBlankIndex: number = -1;
    public activeInput: string = '';

    // 이미지 표시 비율
    public displayScale: number = 1;
    public imageLoaded: boolean = false;

    private routerSub: any;
    private resizeObserver: any;

    // 한글 조사 패턴 (긴 패턴부터 매칭)
    private JOSA_RE = new RegExp(
        '(으로서|으로써|에서는|에서의|로부터|에게서|으로는|에서도|이라는|이라고|에게는|이었다'
        + '|으로|에서|에게|부터|까지|라는|라고|이다|이며|이고|이나|처럼|만큼|에는|에도|과의|와의'
        + '|은|는|이|가|을|를|의|와|과|에|로|도|만|며|고|나|야|요|서|께)$'
    );

    private stripJosa(word: string): string {
        const w = word.replace(/\s+/g, '').trim();
        const stripped = w.replace(this.JOSA_RE, '');
        return stripped.length >= 2 ? stripped : w;
    }

    private matchAnswer(userAnswer: string, correctWord: string): boolean {
        const u = this.stripJosa(userAnswer);
        const c = this.stripJosa(correctWord);
        return u === c;
    }

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.textbookId = WizRoute.segment.id || '';
        this.pageNum = parseInt(WizRoute.segment.page || '1');

        if (!this.textbookId) {
            this.service.href('/textbook');
            return;
        }

        await this.load();

        this.routerSub = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                const newPage = parseInt(WizRoute.segment.page || '1');
                if (newPage !== this.pageNum) {
                    this.pageNum = newPage;
                    await this.load();
                }
            }
        });
    }

    ngAfterViewInit() {
        if (typeof ResizeObserver !== 'undefined' && this.imageContainer) {
            this.resizeObserver = new ResizeObserver(() => {
                this.updateScale();
            });
            this.resizeObserver.observe(this.imageContainer.nativeElement);
        }
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    public async load() {
        this.loading = true;
        this.checked = false;
        this.answers = {};
        this.score = 0;
        this.correctCount = 0;
        this.activeBlankIndex = -1;
        this.activeInput = '';
        this.imageLoaded = false;
        await this.service.render();

        const { code, data } = await wiz.call("study", {
            textbook_id: this.textbookId,
            page_num: this.pageNum
        });

        if (code === 200) {
            this.textbook = data.textbook;
            this.totalPages = data.total_pages || 0;
            this.blanks = data.blanks || [];
            this.totalBlanks = this.blanks.length;
            this.imageWidth = data.image_width || 0;
            this.imageHeight = data.image_height || 0;

            // 이미지 URL (api.py의 image 함수 호출)
            if (data.image_path) {
                this.imageSrc = `/wiz/api/page.textbook.study/image?textbook_id=${this.textbookId}&page_num=${this.pageNum}&t=${Date.now()}`;
            } else {
                this.imageSrc = '';
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public onImageLoad(event: any) {
        this.imageLoaded = true;
        this.updateScale();
        this.service.render();
    }

    private updateScale() {
        if (!this.imageContainer || !this.imageWidth) return;
        const containerWidth = this.imageContainer.nativeElement.clientWidth;
        this.displayScale = containerWidth / this.imageWidth;
    }

    // 블러 영역 좌표 (표시 기준)
    public blurStyle(blank: any): any {
        const s = this.displayScale;
        const padding = 2;
        return {
            left: (blank.x0 * s - padding) + 'px',
            top: (blank.y0 * s - padding) + 'px',
            width: ((blank.x1 - blank.x0) * s + padding * 2) + 'px',
            height: ((blank.y1 - blank.y0) * s + padding * 2) + 'px',
        };
    }

    public blankClass(blank: any): string {
        const idx = blank.index;
        if (this.checked) {
            if (this.isCorrect(idx)) return 'blur-box correct';
            return 'blur-box wrong';
        }
        if (this.answers[idx] !== undefined) return 'blur-box answered';
        if (this.activeBlankIndex === idx) return 'blur-box active';
        return 'blur-box';
    }

    public clickBlank(blank: any) {
        if (this.checked) return;
        this.activeBlankIndex = blank.index;
        this.activeInput = this.answers[blank.index] || '';
        this.service.render();
        // 포커스는 view에서 #answerInput ref로
        setTimeout(() => {
            const el = document.getElementById('answerInput');
            if (el) el.focus();
        }, 50);
    }

    public submitAnswer() {
        if (this.activeBlankIndex < 0) return;
        this.answers[this.activeBlankIndex] = this.activeInput.trim();
        this.activeBlankIndex = -1;
        this.activeInput = '';
        this.service.render();
    }

    public onInputKeydown(event: any) {
        if (event.key === 'Enter') {
            this.submitAnswer();
        } else if (event.key === 'Escape') {
            this.activeBlankIndex = -1;
            this.activeInput = '';
            this.service.render();
        }
    }

    public answeredCount(): number {
        return Object.keys(this.answers).length;
    }

    public async checkAnswers() {
        this.checked = true;
        this.correctCount = 0;

        for (const blank of this.blanks) {
            const userAnswer = (this.answers[blank.index] || '').trim();
            if (userAnswer && this.matchAnswer(userAnswer, blank.word)) {
                this.correctCount++;
            }
        }

        this.score = this.totalBlanks > 0
            ? Math.round((this.correctCount / this.totalBlanks) * 100)
            : 0;

        await wiz.call("save_progress", {
            textbook_id: this.textbookId,
            page_num: this.pageNum,
            total_blanks: this.totalBlanks,
            correct_count: this.correctCount,
            score: this.score
        });

        this.activeBlankIndex = -1;
        await this.service.render();
    }

    public isCorrect(index: number): boolean {
        if (!this.checked) return false;
        const userAnswer = (this.answers[index] || '').trim();
        const blank = this.blanks.find((b: any) => b.index === index);
        return blank && userAnswer !== '' && this.matchAnswer(userAnswer, blank.word);
    }

    public isWrong(index: number): boolean {
        if (!this.checked) return false;
        return !this.isCorrect(index);
    }

    public getCorrectAnswer(index: number): string {
        const blank = this.blanks.find((b: any) => b.index === index);
        return blank ? blank.word : '';
    }

    public async retry() {
        this.checked = false;
        this.answers = {};
        this.score = 0;
        this.correctCount = 0;
        this.activeBlankIndex = -1;
        // 새로운 랜덤 빈칸으로 다시 로드
        await this.load();
    }

    public async goPage(num: number) {
        if (num < 1 || num > this.totalPages) return;
        this.service.href(`/textbook/${this.textbookId}/${num}`);
    }

    public prevPage() { this.goPage(this.pageNum - 1); }
    public nextPage() { this.goPage(this.pageNum + 1); }
    public goList() { this.service.href('/textbook'); }
}

export default PageTextbookStudyComponent;